/* eslint-disable react/jsx-pascal-case */
import React from "react"
import { Flex } from "@mantine/core"
import {
    MRT_ToggleFiltersButton,
    MRT_ToggleGlobalFilterButton,
    MRT_ToggleDensePaddingButton,
    MRT_ToggleFullScreenButton,
    type MRT_TableInstance,
} from "mantine-react-table"

interface Props<TData extends Record<string, any> = NonNullable<unknown>> {
    table: MRT_TableInstance<TData>
}

/**
 * Copied directly from Mantine-Table-React source, but we're disabling _just_ the Hide/Re-order columns menu,
 * because the reset button is broken. We can delete this and use the original if we ever fix that.
 */

export const renderToolbarInternalActions = <TData extends Record<string, any> = NonNullable<unknown>>({
    table,
}: Props<TData>) => {
    const {
        options: {
            columnFilterDisplayMode,
            enableColumnFilters,
            enableDensityToggle,
            enableFilters,
            enableFullScreenToggle,
            enableGlobalFilter,
            initialState,
        },
    } = table

    return (
        <Flex
            sx={{
                alignItems: "center",
                gap: "2px",
                zIndex: 3,
            }}
        >
            {enableFilters && enableGlobalFilter && !initialState?.showGlobalFilter && (
                <MRT_ToggleGlobalFilterButton data-plum-id="global-search" table={table} />
            )}
            {enableFilters && enableColumnFilters && columnFilterDisplayMode !== "popover" && (
                <MRT_ToggleFiltersButton data-plum-id="global-filter-icon" table={table} />
            )}
            {enableDensityToggle && <MRT_ToggleDensePaddingButton table={table} />}
            {enableFullScreenToggle && <MRT_ToggleFullScreenButton table={table} />}
        </Flex>
    )
}
